let api = {};

const pre_v1 = "/api/v1";
const pre_v2 = "/api/e1";
const pre_v3 = "/api/d1";
// 登录
api.login = "/api/login";

// 配置项
api.configType = pre_v1 + "/config/type";

//充电桩型号
api.pileType = pre_v1 + "/piletype";

// 区域省市区
api.areaList = pre_v3 + "/area/list";
// user
api.user = {
  list: pre_v3 + "/user",
  supplierusercheck: pre_v1 + "/user",
  currentUserInfo: pre_v3 + "/user/info/current", //获取当前用户信息
  cust: pre_v1 + "/cust",
  userPwdReset: pre_v3 + "/user/userPwdReset",
};

api.menu = {
  allList: pre_v3 + "/menu/list",
};

// 亲友共享(AXB 598)
api.familyShare = {
  page: pre_v3 + "/familyShare/admin/page",
  isAxbDevice: pre_v3 + "/familyShare/admin/isAxbDevice",
};
// role
api.role = {
  list: pre_v3 + "/role",
  listmenu: pre_v3 + "/role/listmenu",
  allrole: pre_v3 + "/role/list",
};

api.config = {
  list: pre_v3 + "/config/list",
  add: pre_v3 + "/config/add",
  delete: pre_v3 + "/webRequest/pileImgLib/delete",
  config: "/api/v1/config",
};

//仪表盘
// api.dashboard = {
//     pileandorderdto: pre_v1 + "/dashboard/pileandorderdto",
//     leftorderdto: pre_v1 + "/dashboard/leftorderdto",
//     dayorderdto: pre_v1 + "/dashboard/dayorderdto",
//     monthtrend: pre_v1 + "/dashboard/monthtrend",
//     daytrend: pre_v1 + "/dashboard/daytrend",
//     middlestations: pre_v1 + "/dashboard/middlestations",
//     abnormalCount: pre_v1 + "/dashboard/abnormalCount",
//     processingOrder: pre_v1 + "/pileorder/processingOrder",
//     handlerOrder: pre_v1 + "/pileorder/handlerOrder",
// };

//充电站
api.pilestation = {
  pilestation: pre_v1 + "/pilestation",
  list: pre_v1 + "/pilestation/list",
  rpt: pre_v1 + "/pilestation/rpt",
  findno: pre_v1 + "/pilecharge/findno",
  //根据充电网点找出的充电记录
  record: "/api/v1/pilestation/dealerstrategyrecord",
  //根据充电网点找出的账单
  bill: "/api/v1/pilestation/exportbillpdf",
  //导出
  export: "/api/v1/pilestation/exportbill",
  addpile: pre_v1 + "/pilestation/addpiletostation",
  delpile: pre_v1 + "/pilestation/deleteppilefromstation",
  delAppImg: pre_v1 + "/pilestation/deleteappimgs",
  pilelist: pre_v1 + "/pile/list",
  rptfrom: pre_v1 + "/pilestation/rptfrom",
  rptchart: pre_v1 + "/pilestation/rptchart",
  uploadFile: pre_v1 + "/pilestation/uploadFile",
  changeStationState: pre_v1 + "/pilestation/nullify",
};
//客户管理
// api.cust = {
//     pagecust: pre_v1 + "/cust/pagecust",
//     cust: pre_v1 + "/cust/findbyid",
//     addupdatecust: pre_v1 + "/cust/addupdatecust",
//     targetremark: pre_v1 + "/cust/targetremark",
//     custwalletlist: pre_v1 + "/custwalletlist",
//     addtarget: "/api/v1/cust/addtarget",
//     allDealer: pre_v1 + "/dealer",
//     chargeCardList: pre_v1 + "/chargeCardList",
//     //充值退款
//     addCardList: pre_v1 + "/chargeCardList/addCardList",
//     editCardList: pre_v1 + "/chargeCardList/editCardList",
//     exportCustList: pre_v1 + "/cust/exportCustList",
//     findCustPhoneList: pre_v1 + "/cust/findCustPhoneList",
// };
//订单管理
api.order = {
  pileorder: pre_v1 + "/pileorder",
  dealorderreply: pre_v1 + "/pileOrderReply/dealorderreply",
  updatechargestep: pre_v1 + "/pileorder/updatechargestep",
  updateRemark: pre_v1 + "/pileorder/updateRemark",
  exportOrderList: pre_v3 + "/pileorder/exportOrderList",
  findType: pre_v1 + "/pileorder/findType",
  findStation: pre_v1 + "/pileorder/findStation",
};
//服务记录
api.feedback = {
  serviceFeedback: pre_v1 + "/serviceFeedback",
};
//移动端管理
api.mobile = {
  banner: pre_v1 + "/banner",
  findList: pre_v1 + "/banner/findList",
};
//推送日志
api.push = {
  page: "/api/m1/pushrecord/page",
};
// 消息推送 - 站内信记录
api.messagePush = {
  page: pre_v3 + "/privateMes/warnMsg/page",
};
// 系统-消息通知
api.massaage = pre_v2 + "/warnmsg";

//运营商管理
// api.dealer = {
//     list: pre_v1 + "/dealer/page",
//     allList: pre_v1 + "/dealer/list",
//     dealer: pre_v1 + "/dealer",
//     addbank: pre_v1 + "/dealer/addbank",
//     editbank: pre_v1 + "/dealer/editbank",
//     editattach: pre_v1 + "/dealer/editattach",
//     removeattach: pre_v1 + "/dealer/removeattach",
//     addattach: pre_v1 + "/dealer/addattach",
//     removebank: pre_v1 + "/dealer/removebank",
//     addpiletostation: pre_v1 + "/pilestation/addpiletostation",
//     updstation: pre_v1 + "/dealer/updstation",
//     edit: pre_v1 + "/dealer/edit",
//     rptchart: pre_v1 + "/dealer/rptchart",
//     rpt: pre_v1 + "/dealer/rpt",
//     rptinfo: pre_v1 + "/dealer/rptinfo",
//     // custlinedata: pre_v1 + '/cust/findByCreateTime',
//     rptform: pre_v1 + "/dealer/rptform",
//     getDealList: pre_v1 + "/dealer/getDealList",
//     findByDealNo: pre_v1 + "/dealer/findByDealNo",
// };

//财务管理
// api.finance = {
//     calcpage: pre_v1 + "/dealer/calcpage",
//     revieworders: pre_v1 + "/pileorder/revieworders",
//     checkorders: pre_v1 + "/pileorder/checkorders",
//     cashOut: pre_v1 + "/cashOut/findCashList",
//     updateCashout: pre_v1 + "/cashOut/updateCashout",
//     powerStationStatement: pre_v1 + '/dealer/powerStationStatement',
//     export: pre_v1 + '/dealer/export'
// };

//h5 api
// api.h5 = {
//     chargeCards: pre_v1 + "/app/chargeCard/chargecardList",
//     consumption: pre_v1 + "/app/chargecard/pileorderList",
//     rangeList: pre_v1 + "/app/chargecard/stationList",
//     reChargeList: pre_v1 + "/app/chargecard/chargeList",
//     exchangeCards: pre_v1 + "/app/chargeCard/exchangeCard",
// };

//活动管理
// api.serviece = {
//     add: pre_v2 + "/activity/saveActivity", //发布活动/URL导入
//     list: pre_v2 + "/activity/getActivityList", //列表
//     change: pre_v2 + "/activity/updateActivityStatus", //活动下架,发布
//     del: pre_v2 + "/activity/", //删除
//     edit: pre_v2 + "/activity/updateActivity", //编辑确认
//     upImage: pre_v2 + "/attachment/saveFile", //上传图片
//     findInfo: pre_v2 + "/activity/findInfoById/", //回收站详情
// };
// api.commodity = {
//     list: pre_v2 + "/commodity", //列表
//     up: pre_v2 + "/commodity/put", //商品上架
//     down: pre_v2 + "/commodity/offCommodity", //商品下架
//     file: pre_v2 + "/attachment/saveFile", //附件上传
//     delFile: pre_v2 + "/attachment/", //删除附件
//     export: pre_v2 + "/commodity/export", //导出文件
// };

// 对账
// api.reconciliation = {
//     page: pre_v1 + "/reconciliation/page",
//     reconciliationExport: pre_v1 + "/reconciliation/reconciliationExport",
// }
// api.reconciliationTask = {
//     add: pre_v1 + "/reconciliationTask/add",
//     page: pre_v1 + "/reconciliationTask/page",
//     findFlag: pre_v1 + "/reconciliationTask/findFlag",
//     findByCorpNo: pre_v1 + "/reconciliationTask/findByCorpNo",
// }

/**
 * 数字化交流桩
 * WEB
 * */

api.digitization = {
  // 充电桩管理 - 列表
  pileList: pre_v3 + "/pile/page",
  // 充电桩管理 - 编辑保存
  editPile: pre_v3 + "/pile/edit",
  // 充电桩管理 - 编辑根据Id查详细信息
  pileInfo: pre_v3 + "/pile/info",
  // 充电桩管理 - 充电记录
  pileOrder: pre_v3 + "/pileorder/page",
  // 充电桩管理 - 关联账号
  // pileCust: pre_v3 + "/pileCust/page",
  pileCust: pre_v3 + "/pileCust/page2",

  // 充电桩型号管理 - 新增保存
  pileTypeAdd: pre_v3 + "/piletype/add",
  // 充电桩型号管理 - 编辑保存
  pileTypeEdit: pre_v3 + "/piletype/edit",
  // 充电桩型号管理 - 编辑根据Id查详细信息
  pileTypeInfo: pre_v3 + "/piletype/info",

  // 客户管理 - 列表
  // custList: pre_v1 + "/cust/page",
  custList: pre_v1 + "/cust/pagecust",
  // 客户管理 - 车辆信息
  custVehicle: pre_v3 + "/custVehicle/page",

  // 移动端 - 通知管理
  pileMessage: pre_v3 + "/pileMessage/page",
  // 移动端 - 通知管理 - 新增
  pileMessageAdd: pre_v3 + "/pileMessage/add",
  // 移动端 - 通知管理 - 编辑
  pileMessageEdit: pre_v3 + "/pileMessage/edit",
  // 移动端 - 通知管理 - 详情
  pileMessageInfo: pre_v3 + "/pileMessage/findById/",
  // 移动端 - 通知管理 - 设置启用
  pileMessageFlag: pre_v3 + "/pileMessage/updateInvokeFlag",
  // web端 - 车辆品牌管理
  vehicleBrand: pre_v3 + "/vehicleBrand/page",
  // web端 - 车辆品牌管理
  vehicleBrandAll: pre_v3 + "/vehicleBrand/list",
  // web端 - 车辆品牌管理-新增
  vehicleBrandAdd: pre_v3 + "/vehicleBrand/add",
  // web端 - 车辆品牌管理-编辑
  vehicleBrandEdit: pre_v3 + "/vehicleBrand/edit",
  // // web端 - 车辆型号管理
  // vehicleModel: pre_v3 + "/vehicleModel/page",

  // 移动端、web端 - 车辆型号管理
  vehicleModel: pre_v3 + "/vehicleModel/page",
  // 移动端 - 车辆型号管理 - 新增
  vehicleModelAdd: pre_v3 + "/vehicleModel/add",
  // 移动端 - 车辆型号管理 - 编辑
  vehicleModelEdit: pre_v3 + "/vehicleModel/edit",
  // 移动端 - 车辆型号管理 - 详情
  vehicleModelInfo: pre_v3 + "/vehicleMode/findById/",
  // 移动端 - 车辆型号管理 - 设置启用
  vehicleModelFlag: pre_v3 + "/vehicleModel/updateInvokeFlag",

  // 图片上传
  imgUpload: pre_v3 + "/piletype/upload",

  // 充电桩管理
  // 列表数据
  pileFunctionPage: pre_v3 + "/pileFunction/page",
  // 型号新增
  pileFunctionAdd: pre_v3 + "/pileFunction/addPileFunction",
  // 型号编辑
  pileFunctionEdit: pre_v3 + "/pileFunction/editPileFunction",
  // 图片上传
  pileFunctionImgUpload: pre_v3 + "/pileFunction/upload",
  // 根据id查询
  findPileFunctionByNo: pre_v3 + "/pileFunction/findPileFunctionByNo",
  // 保存充电桩型号-其他嵌入式版本（content 为实体数组）
  savePileVersion: pre_v3 + "/pileFunction/savePileVersion",
  // 编辑充电桩型号-其他嵌入式版本
  updatePileVersion: pre_v3 + "/pileFunction/updatePileVersion",
  // 其他嵌入式版本详情（按 functionId 查询）
  findByFunctionId: pre_v3 + "/pileFunction/findByFunctionId",
  // 仅新增其他嵌入式版本（请求体为单个实体 JSON）
  onlyAddPileFunction: pre_v3 + "/pileFunction/onlyAddPileFunction",
  // 嵌入式版本行启用/禁用（status：0 启用 1 禁用）
  pileTypeVersionEdit: pre_v3 + "/pileTypeVersion/edit",

  // 充电桩 - 个人站
  getPilePage: pre_v3 + '/webRequest/pile/page', // 充电桩、设备列表
  getPileInfo: pre_v3 + '/webRequest/pile/getPileInfo', // 充电桩、设备详情
  // getPileInfo: pre_v3 + "/pile/getPileInfo", // 旧

  // 成品料号 - 数据筛选
  getMaterialNoList: pre_v3 + '/webRequest/pile/getMaterialNoList',

  // 充电设备管理 - 共享开关设备列表
  getShareDevicePage: pre_v3 + '/webRequest/deviceShare/page', // 来管设备、设备列表
  getShareDeviceInfo: pre_v3 + '/webRequest/deviceShare/getShareDeviceInfo', // 开关设备、设备详情 、用户 - 共享开关信息详情
  getShareDeviceCustInfo: pre_v3 + '/webRequest/deviceShare/getShareDeviceCustInfo', // 用户信息
  getShareDeviceRecord: pre_v3 + '/webRequest/deviceShare/getShareDeviceRecord', // 报文日志
  // 共享用户管理（私桩共享信息详情页 - 用户列表 + 变更记录）
  shareUserList: pre_v3 + '/webRequest/shareUser/list', // 共享用户列表
  shareUserRelationLog: pre_v3 + '/webRequest/shareUser/relationLog', // 用户关系变更记录
  shareFavoriteList: pre_v3 + '/webRequest/shareFavorite/list', // 共享站点收藏列表（用户详情页 - 私桩共享信息 tab）
  shareMessagePreference: pre_v3 + '/webRequest/shareMessage/preference', // 共享消息偏好查询（用户详情页 - 私桩共享信息 tab）
  shareMessageLog: pre_v3 + '/webRequest/shareMessage/log', // 共享消息通知日志（用户详情页 - 私桩共享信息 tab）
  getShareDeviceErrorInfo: pre_v3 + '/webRequest/deviceShare/getShareDeviceErrorInfo', // 故障信息
  exportDeviceShareLockList: pre_v3 + '/webRequest/deviceShare/exportDeviceShareLockList', // 共享开关设备列表导出
  exportDeviceShareLockOrder: pre_v3 + '/webRequest/deviceShare/exportDeviceShareLockOrder', // 共享充电订单导出

  // 个人站共享订单
  chargePileOrderList: pre_v3 + '/webRequest/order/chargePileOrderList', // 共享充电订单 - 列表
  normalSettle: pre_v3 + '/webRequest/abnormalShareOrder/normalSettle', // 共享充电订单 - 正常结算
  abnormalSettle: pre_v3 + '/webRequest/abnormalShareOrder/abnormalSettle', // 共享充电订单 - 线下结算
  getChargeOrderInfo: pre_v3 + '/webRequest/deviceShare/getChargeOrderInfo', // 共享充电订单 - 详情
  getAlipayLogonId: pre_v3 + '/webRequest/operation/refunds/getAlipayLogonId', // 获取交易单的支付宝账号
  createManualRefund: pre_v3 + '/webRequest/operation/refunds/createManualRefund', // 充电订单售后退款
  manualRefund: pre_v3 + '/webRequest/operation/refunds/manual', // 充电订单售后退款(新)
  sharePileOrderList: pre_v3 + '/webRequest/order/sharePileOrderList', // 共享预约订单 - 列表
  getShareOrderInfo: pre_v3 + '/webRequest/deviceShare/getShareOrderInfo', // 共享预约订单 - 详情

  // 个人站运营管理 - 个人站运营统计
  getOperationReport: pre_v3 + '/webRequest/operationReport',



  // 订单管理
  // 充电订单管理列表数据
  custwalletList: pre_v3 + "/pileorder/page",

  // 支付订单管理 列表数据
  custwalletlist: pre_v3 + "/custwalletlist/page",
  // 支付订单管理 订单详情
  findListById: pre_v3 + "/custwalletlist/findById",
  // 制度订单管理 订单导出
  custwalletExcel: pre_v3 + "/custwalletlist/excel",

  // 充电桩管理 - 充电记录 - 折线图
  pileAreaDataList: pre_v3 + "/pileorder/areaDataList",

  // 配置项
  configType: pre_v3 + "/config/type",
  //修改日志
  webLog: pre_v3 + "/webLog/page",
  // 解绑
  unBindPile: pre_v3 + "/app/custpile/unBindPile",

};
// 重构-客户
api.cust = {
  // list: pre_v3 + "/cust/listAll",  // 旧
  list: pre_v3 + "/webRequest/cust/listAll",  // 旧

  pileList: pre_v1 + "/pile/list",
  custpile: pre_v3 + "/custpile/list",
  listCustRelation: pre_v3 + "/cust/listCustRelation", //获取用户所有亲友信息
  listHirtoryCustRelation: pre_v3 + "/cust/listHirtoryCustRelation", //获取用户所有亲友信息
  getVehcileInfo: pre_v3 + "/vehcile/getVehcileInfo", //获取用户所有亲友信息
  custVehicleList: pre_v3 + "/app/custVehicle/list", // 客户车辆列表
  getPileInfo: pre_v3 + "/pile/getPileInfo", //获取用户所有桩信息
  getPileOrder: pre_v3 + "/pileOrder/listAllPileOrder", //获取用户充电订单列表
  getPileOrderList: pre_v3 + "/pileOrder/list", //获取用户收益订单列表
  getTotal: pre_v3 + "/wallet/getTotal", //获取用户购买总数
  pileUseWalletListWebList: pre_v3 + "/wallet/pileUseWalletListWebList", //获取用户购买列表
  getSharePileList: pre_v3 + "/aliMiniPro/pileShare/getSharePileList", //查询共享桩列表
  getIntegralList: pre_v3 + "/integral/list", //查询积分详情
  getIntegralPage: pre_v3 + "/integral/page", //查询积分详情
  getSumIntegralCount: pre_v3 + "/integral/getSumIntegralCount", //获取累计获取/消耗总量


  // 私桩共享信息
  getSharePileBasicInfo: pre_v3 + '/webRequest/device/getSharePileBasicInfo', // 设备、私桩高洪祥信息（充电桩和开关）
  getSharePriceTime: pre_v3 + '/webRequest/device/getSharePriceTime', // 设备、私桩共享信息价格时段
  findTimeSlotByDeviceCode: pre_v3 + '/webRequest/device/findTimeSlotByDeviceCode', // 设备、私桩共享信息开放时间
  resetSharePileBasicInfo: pre_v3 + '/webRequest/device/resetSharePileBasicInfo', // 重新开通身份认证
  getUserList: pre_v3 + '/webRequest/device/findPileShareBlackCust', // 用户列表

  // 订单管理
  getChargePileOrder: pre_v3 + '/webRequest/device/getChargePileOrder', // 获取充电订单
  getSharePileOrder: pre_v3 + '/webRequest/device/getSharePileOrder', // 获取预约订单
  getCount: pre_v3 + '/webRequest/profitStatistics/count', // 统计总览
  getLineChart: pre_v3 + '/webRequest/profitStatistics/lineChart',

  // 钱包信息
  getWithdraw: pre_v3 + '/webRequest/cust/Withdraw', // 数据统计
  getWithdrawLog: pre_v3 + '/webRequest/cust/WithdrawLog', // 表格数据

};
// 充电桩
api.pile = {
  list: pre_v3 + "/pile/edit",
  pile: pre_v1 + "/pile/pilepage",
  //充电记录
  pileorder: pre_v1 + "/pileorder",
  //维修
  pilerepair: pre_v1 + "/pilerepair",
  //用户反馈列表
  findByNo: pre_v1 + "/pilerepair/findByNo",
  //报文日志
  getPileRecord: pre_v3 + "/pile/getPileRecord",
  //故障信息
  getErrorInfo: pre_v3 + "/pile/getErrorInfo",
  //用户信息
  listPileCust: pre_v3 + "/cust/listPileCust",
  // 充电桩成品料号list
  pileFunction: pre_v3 + "/pileFunction/list",
  // 历史充电桩信息
  pileUseWalletListHistory: pre_v3 + "/wallet/pileUseWalletListHistory",
  // 历史用户信息
  listHirtoryRelation: pre_v3 + "/cust/listHirtoryRelation",
  // 私桩升级
  upgradeManager: pre_v3 + "/upgradeManager/list",
  //预约策略
  getReservation: pre_v3 + "/pileOrder/getReservation",
  //获取保质期历史记录
  listHistory: pre_v3 + "/bind/listHistory",
  //更改保质期历史记录到期时间
  editBindTime: pre_v3 + "/bind/editBindTime",
  //故障记录
  pileWarn: "/api/m1/pileWarn/page",
  //故障备注
  warn: "/api/m1/pileWarn/edit",
  dealer: "/api/v1/dealer/list",
  type: "/api/v1/piletype/list",
  pileCharge: "/api/v1/pilecharge/list",
  findByPileCode: pre_v1 + "/pile/findByPileCode",
  //解绑
  unBindPile: pre_v1 + "/app/custpile/unBindPile",
  updatePileDetail: pre_v1 + "/pile/updatePileDetail",
  findById: pre_v1 + "/pile/findById",
  exportPile: pre_v1 + "/pile/exportPile",
  findPileCodeList: pre_v1 + "/pile/findPileCodeList",
  listManufactorId: pre_v3 + "/pileFunction/listManufactorId", //厂商标识
  listFeign: pre_v3 + "/pileFunction/list", //充电桩型号
};
// 私桩共享
api.privatePile = {
  //私桩充电订单列表分页接口
  pileOrder: pre_v3 + "/pileOrder/pageOrder",
  //共享桩充电订单列表分页接口
  findShareRecord: pre_v3 + "/aliMiniPro/pileShare/findShareRecord",
  //支付订单列表分页接口
  pileUseWalletListWeb: pre_v3 + "/wallet/pileUseWalletListWeb",
  //查询共享桩详情
  getSharePileInfo: pre_v3 + "/aliMiniPro/pileShare/getSharePile",
  //查询共享桩分享用户列表
  findApplyPage: pre_v3 + "/aliMiniPro/pileShare/findApplyPage",
  //查询共享桩共享订单信息
  updateOrder: pre_v3 + "/aliMiniPro/pileShare/updateOrder",
};
api.custVersion = {
  page: pre_v3 + "/custVersion/page",
  add: pre_v3 + "/custVersion/add",
  edit: pre_v3 + "/custVersion/edit",
  check: pre_v3 + "/custVersion/check",
  getHistoryVersion: pre_v3 + "/custVersion/getHistoryVersion",
  // 获取版本号
  version: pre_v3 + "/version/list",
  // list : pre_v3 + '/custVersion/list'
};

api.upgradeManager = {
  page: pre_v3 + "/upgradeManager/page",
  edit: pre_v3 + "/upgradeManager/edit",
};
api.appVersion = {
  appversion: pre_v3 + "/appversion",
  getHistory: pre_v3 + "/appversion/getHistory",
};
api.mayiEnerge = {
  getList: pre_v3 + "/aliMiniPro/greenenergy/queryGreenEnergyRecharge",
  statsGreenEnergyRecharge:
    pre_v3 + "/aliMiniPro/greenenergy/statsGreenEnergyRecharge",
  addGreenEnergyRecharge:
    pre_v3 + "/aliMiniPro/greenenergy/addGreenEnergyRecharge",
  queryGeRecordPage: pre_v3 + "/aliMiniPro/greenenergy/queryGeRecordPage",
  setOnOff: pre_v3 + "/aliMiniPro/greenenergy/setOnOff",
  publish: pre_v3 + "/aliMiniPro/greenenergy/publishWeb",
  query: pre_v3 + "/aliMiniPro/greenenergy/query",
};

// 营销活动
api.activityOrder = {
  list: pre_v3 + "/web/activity/orderPage",
  pileActivityOrderPage: pre_v3 + "/activityOrder/pileActivityOrderPage",
  get: pre_v3 + "/activityOrder/get",
  update: pre_v3 + "/activityOrder/update",
  edit: pre_v3 + "/web/activity/edit",
  refundEdit: pre_v3 + "/web/activity/refundEdit",
  refundAudit: pre_v3 + "/web/activity/refundAudit",
  findAuditRecordPage: pre_v3 + "/web/activity/findAuditRecordPage",
  activateExchange: pre_v3 + "/web/activity/activateExchange",
  pileActivateExchange: pre_v3 + "/activityOrder/activateExchange",
  // findByNo: pre_v3 + "/web/activity/findByActivityOrderNo",
  findByNo: pre_v3 + "/web/activity/findByActivityOrderId",
  checkMobileQuery: pre_v3 + "/web/activity/checkMobileQuery",
  setOnOff: pre_v3 + "/web/activity/setOnOff",
  export: pre_v3 + "/web/activity/excel",
  couponExchangePage: pre_v3 + "/web/coupon/couponExchangePage",
  couponExport: pre_v3 + "/web/coupon/couponExchangeExcel",
  serviceBillList: pre_v3 + "/activityOrderPlatformWithHoldRecord/serviceBillList",
  serviceBillListExcel: pre_v3 + "/activityOrderPlatformWithHoldRecord/serviceBillListExcel",
  refundOrderList: pre_v3 + "/activityOrderWalletList/refundOrderList",
  refundOrderListExcel: pre_v3 + "/activityOrderWalletList/refundOrderListExcel",
  commodityOrderList: pre_v3 + "/activityOrderActivityMap/commodityOrderList", // 总商品订单列表
  activityCommodityOrderList: pre_v3 + "/activityOrderActivityMap/activityCommodityOrderList", // 家庭充电商品订单列表
  commodityOrderListExcel: pre_v3 + "/activityOrderActivityMap/commodityOrderListExcel",
  activityCommodityOrderListExcel: pre_v3 + "/activityOrderActivityMap/activityCommodityOrderListExcel", // 家庭充电商品订单导出
  registerUserOrderInfo: pre_v3 + "/activityOrder/registerUserOrderInfo", // 报名用户订单列表
  registerUserOrderInfoExcel: pre_v3 + "/activityOrder/registerUserOrderInfoExcel",
  packageList: pre_v3 + "/activityOrderZeroPayConfiguration/page", // 套餐列表查询
  editPackage: pre_v3 + "/activityOrderZeroPayConfiguration/edit", // 套餐列表修改
  addPackage: pre_v3 + "/activityOrderZeroPayConfiguration/add", // 套餐列表添加
  serviceActivityId: pre_v3 + "/activityOrderZeroPayConfiguration/findByServiceActivityId", // 查询操作记录
  findOne: pre_v3 + "/activityOrderZeroPayConfiguration/findOne",
  serviceBillCount: pre_v3 + "/activityOrderPlatformWithHoldRecord/serviceBillCount",
  newActivityRefund: pre_v3 + "/activityOrderCancelRequestRecord/newActivity/refund", // 家庭充电订单退款(用桩服务)
  newActivityBuyoutRefund: pre_v3 + "/activityOrderCancelRequestRecord/orderBuyOut/refund", // 家庭充电订单退款(买断服务)
  setCheckOnce: pre_v3 + "/activityOrder/setCheckOnce", // 用户验证设置
  pileActivityOrderExcel: pre_v3 + "/activityOrder/pileActivityOrderExcel", // 家庭充电服务活动订单导出
  circuitBreakerActivityOrderPage: pre_v3 + "/activityOrder/circuitBreakerActivity/activityOrderPage", // 空开/送桩活动服务列表（通过 activityExtendTypeEnum 区分）
  circuitBreakerActivityOrderPageExcel: pre_v3 + "/activityOrder/circuitBreakerActivity/activityOrderPageExcel", // 空开活动服务列表导出（旧）
  circuitBreakerActivityPileActivityOrderExcel: pre_v3 + "/activityOrder/circuitBreakerActivity/pileActivityOrderExcel", // 空开/送桩活动服务列表导出（通过 activityExtendTypeEnum 区分）
  circuitBreakerActivityGet: pre_v3 + "/activityOrder/circuitBreakerActivity/get", // 空开活动订单详情
  circuitBreakerActivityCancelRecordPage: pre_v3 + "/activityOrderDataPurchaseRecord/circuitBreakerActivity/page", // 解约/买断申请记录分页（空开活动）
  trafficStatistics: pre_v3 + "/activityOrderDataPurchaseRecord/circuitBreakerActivity/trafficStatistics", // 流量服务统计（空开/送桩）
  circuitBreakerActivityTrafficBillsPage: pre_v3 + "/activityOrderDataPurchaseRecord/circuitBreakerActivity/page", // 流量服务账单分页（空开/送桩）
  trafficStatisticsPage: pre_v3 + "/activityOrderDataPurchaseRecord/newActivity/page", // 流量服务账单分页（空开/新活动）
  circuitBreakerActivityCommodityOrderList: pre_v3 + "/activityOrderActivityMap/circuitBreakerActivity/activityCommodityOrderList", // 空开/送桩商品订单列表（通过 activityType 区分）
  // 安心包598
  axbPileActivityOrderPage: pre_v3 + "/axbApp/pileActivityOrderPage", // 安心包598服务列表
  axbPileActivityOrderExcel: pre_v3 + "/axbApp/pileActivityOrderExcel", // 安心包598服务列表导出
  axbAppGet: pre_v3 + "/axbApp/get", // 安心包598活动订单详情
  axbActivityCommodityOrderList: pre_v3 + "/axbApp/activityCommodityOrderList", // 安心包598商品订单列表
  axbActivityCommodityOrderListExcel: pre_v3 + "/axbApp/activityCommodityOrderListExcel", // 安心包598商品订单导出
  axbTrafficStatistics: pre_v3 + "/axbApp/trafficStatistics", // 安心包598流量统计
  axbNewActivityRefund: pre_v3 + "/axbApp/newActivity/refund", // 安心包598退款
  axbActivityExports: pre_v3 + "/webRequest/axbActivity/export", // 安心包598活动导出
  axbActivityChannelExport: pre_v3 + "/webRequest/axbActivity/channelExport", // 支付宝活动链接导出
  axbDeleteActivity: pre_v3 + "/webRequest/axbActivity/deleteActivity", // 安心包598活动重新报名
  axbActivityRefund: pre_v3 + "/webRequest/axbActivity/refund", // 安心包598活动待激活退款
  // 安心包598 售后换桩(web客服端)
  axbPileSwapInitiate: pre_v3 + "/webRequest/pileSwap/initiate", // 发起换桩
  axbPileSwapCancel: pre_v3 + "/webRequest/pileSwap/cancel", // 取消换桩
  axbPileSwapRecordList: pre_v3 + "/webRequest/pileSwap/recordList", // 换桩记录列表
  // 老499活动 售后换桩(web客服端)；换桩记录查询复用上面的 axbPileSwapRecordList(通用接口)
  old499PileSwapInitiate: pre_v3 + "/webRequest/old499PileSwap/initiate", // 老499发起换桩
  old499PileSwapCancel: pre_v3 + "/webRequest/old499PileSwap/cancel", // 老499取消换桩
};

// 流量赠送
api.giftTraffic = {
  // 赠送流量
  gift: pre_v3 + "/axbApp/giftTraffic",
  // 分页查询赠送记录
  recordPage: pre_v3 + "/axbApp/giftRecordPage",
  // 列表查询赠送记录(不分页)
  recordList: pre_v3 + "/axbApp/giftRecordList",
  // 根据ID查询详情
  recordById: pre_v3 + "/axbApp/findGiftRecordById",
  // 导出赠送记录
  exportGiftRecord: pre_v3 + "/axbApp/exportGiftRecord",
};

// 698 小红书分享活动（后台）
api.xhsActivity = {
  // 笔记记录分页（21 列）；pageNum 为 1-based
  page: pre_v3 + "/xhsActivity/admin/page",
  // 单订单笔记列表（笔记序号从 1 起，历史未通过记录占号）
  listByOrder: pre_v3 + "/xhsActivity/admin/listByOrder",
  // 审核（通过/不通过）；审核人由后端取登录态
  audit: pre_v3 + "/xhsActivity/admin/audit",
  // 发放奖励；发放人由后端取登录态
  grant: pre_v3 + "/xhsActivity/admin/grant",
  // 重试发放（仅发放失败或发放中断超时）
  grantRetry: pre_v3 + "/xhsActivity/admin/grant/retry",
  // 导出（全量命中结果，返回 { filePath }）
  excel: pre_v3 + "/xhsActivity/admin/excel",
};

// 代理商接口（空开/家庭充电共用，通过 activityNo 区分）
api.agent = {
  findByPage: pre_v3 + "/agent/findByPage", // 主列表分页数据
  list: pre_v3 + "/agent/list", // 弹窗内上级代理商下拉（选择二级时调）
  add: pre_v3 + "/agent/add", // 代理商添加
  updateAgentStatus: pre_v3 + "/agent/updateAgentStatus", // 代理商启用/禁用状态更新
};

api.operateStatis = {
  // 运营数据概览
  countStatis: pre_v3 + "/operateStatis/overview/countStatis",
  overviewChart: pre_v3 + "/operateStatis/overview/chart",

  //  用户注册数趋势图
  custRegistChart: pre_v3 + "/operateStatis/custRegist/chart",
  //  用户访问量趋势图
  custTraceChart: pre_v3 + "/operateStatis/custTrace/chart",

  // 活跃用户报表
  custActive: pre_v3 + "/operateStatis/custActive/chart",
  // 活跃用户列表
  custActivePage: pre_v3 + "/operateStatis/custActive/page",

  // 用户签到报表
  custSignInChart: pre_v3 + "/operateStatis/custSignIn/chart",
  // 用户签到列表
  custSignInPage: pre_v3 + "/operateStatis/custSignIn/page",

  // 用户充电习惯报表
  custHabit: pre_v3 + "/operateStatis/custHabit/chart",
  pileOrderChart: pre_v3 + "/operateStatis/pileOrder/chart",
  chargeValueChart: pre_v3 + "/operateStatis/chargeValue/chart",

  // 充电桩绑定报表
  pileBindChart: pre_v3 + "/operateStatis/pileBind/chart",

  // 充电订单报表
  pileOrderTypeChart: pre_v3 + "/operateStatis/pileOrderType/chart",

  // 充电习惯订单分布列表
  pileOrderPage: pre_v3 + "/operateStatis/pileOrder/page",
  // 充电习惯订单日分布列表
  pileOrderDayPage: pre_v3 + "/operateStatis/pileOrderDay/page",
  // 充电习惯订单周分布列表
  pileOrderWeekPage: pre_v3 + "/operateStatis/pileOrderWeek/page",
  // 充电习惯订单月分布列表
  pileOrderMonPage: pre_v3 + "/operateStatis/pileOrderMon/page",
  // 充电习惯订单电量分布列表
  chargeValuePage: pre_v3 + "/operateStatis/chargeValue/page",

  // 私桩共享设置列表
  pileSharePage: pre_v3 + "/operateStatis/pileShare/page",

  // 用户访问量列表
  custTracePage: pre_v3 + "/operateStatis/custTrace/page",

  // 用户注册数列表
  custRegistPage: pre_v3 + "/operateStatis/custRegist/page",

  // 用户信息完善列表
  custCompletePage: pre_v3 + "/operateStatis/custComplete/page",

  // 充电设置列表
  custHabitPage: pre_v3 + "/operateStatis/custHabit/page",
  // 用户信息完善-车型
  vehcileBindPage: pre_v3 + "/operateStatis/vehcileBind/page",

  // 充电桩绑定数列表
  pileBindPage: pre_v3 + "/operateStatis/pileBind/page",

  // 充电桩品类绑定数列表
  pileProductBindPage: pre_v3 + "/operateStatis/pileProductBind/page",

  // 充电订单列表
  pileOrderTypePage: pre_v3 + "/operateStatis/pileOrderType/page",

  // 注册数列表导出
  custRegistExport: pre_v3 + "/operateStatis/custRegist/export",
  // 访问量列表导出
  custTraceExport: pre_v3 + "/operateStatis/custTrace/export",
  // 活跃用户列表导出
  custActiveExport: pre_v3 + "/operateStatis/custActive/export",
  // 用户签到列表导出
  custSignInExport: pre_v3 + "/operateStatis/custSignIn/export",
  // 用户完善列表导出
  custCompleteExport: pre_v3 + "/operateStatis/custComplete/export",
  // 用户完善-车型列表导出
  vehcileBindExport: pre_v3 + "/operateStatis/vehcileBind/export",
  // 充电设置列表导出
  custHabitExport: pre_v3 + "/operateStatis/custHabit/export",
  // 订单分布列表导出
  pileOrderExport: pre_v3 + "/operateStatis/pileOrder/export",
  // 日时段分布列表导出
  pileOrderDayExport: pre_v3 + "/operateStatis/pileOrderDay/export",
  // 周时段分布列表导出
  pileOrderWeekExport: pre_v3 + "/operateStatis/pileOrderWeek/export",
  // 月时段分布列表导出
  pileOrderMonExport: pre_v3 + "/operateStatis/pileOrderMon/export",
  // 充电量列表导出
  chargeValueExport: pre_v3 + "/operateStatis/chargeValue/export",
  // 私桩共享列表导出
  pileShareExport: pre_v3 + "/operateStatis/pileShare/export",
  // 品类绑定数列表导出
  pileProductBind: pre_v3 + "/operateStatis/pileProductBind/export",
  // 绑定数列表导出
  pileBindExport: pre_v3 + "/operateStatis/pileBind/export",
  // 订单类型列表导出
  pileOrderType: pre_v3 + "/operateStatis/pileOrderType/export",
};

api.coupon = {
  list: pre_v3 + '/coupon/list',
  page: pre_v3 + '/coupon/page',
  add: pre_v3 + '/coupon/add',
  edit: pre_v3 + '/coupon/edit',
  advert: pre_v3 + '/advert',
  upload: pre_v3 + '/coupon/upload',
  getEidtHistory: pre_v3 + '/coupon/getEidtHistory',
  exchangePage: pre_v3 + '/coupon/exchange/page',
  couponExport: pre_v3 + '/coupon/couponExport',
  advertisement: pre_v3 + '/advertisement',
  advertPictureAdd: pre_v3 + '/advertPicture/add',
  advertPictureEdit: pre_v3 + '/advertPicture/edit',
  advertPictureReplace: pre_v3 + '/advertPicture/replace',
  advertPictureEditStatus: pre_v3 + '/advertPicture/editStatus',
  advertPictureList: pre_v3 + '/advertPicture/list',
  advertGetEidtHistory: pre_v3 + '/advertPicture/getEidtHistory',

  announcementPage: pre_v3 + '/announcement/page',
  announcementAdd: pre_v3 + '/announcement/add',
  announcementEdit: pre_v3 + '/announcement/edit',

  integralConfigPage: pre_v3 + '/integralConfig/page',
  integralConfigList: pre_v3 + '/integralConfig/list',
  integralConfigAdd: pre_v3 + '/integralConfig/add',
  integralConfigEdit: pre_v3 + '/integralConfig/Edit',
};

// 0元参与活动
api.zeropay = {
  // 分页查询
  list: pre_v3 + '/activityOrderZeroPay/page', // 分页
  detail: pre_v3 + '/activityOrderZeroPay/findById/', // {id}
  edit: pre_v3 + '/activityOrderZeroPay/edit', // 编辑
  orderDetail: pre_v3 + '/activityOrderPlatformWithHoldRecord/findByNo', // 服务账单明细
  orderDetailRefund: pre_v3 + '/activityOrderPlatformWithHoldRecord/activityOrderDeductionRefund',
  cancelOrderRecord: pre_v3 + '/activityOrderCancelRequestRecord/findByNo', // 解约申请记录
  cancelOrderRecordPage: pre_v3 + '/activityOrderCancelRequestRecord/activityCancelRequestRecordPage', // 解约申请记录分页查询
  cancelOrderRecordPageAxbApp: pre_v3 + '/axbApp/activityCancelRequestRecordPage', // 安心包解约申请记录分页查询
  exportList: pre_v3 + '/activityOrderZeroPay/excel', // 导出
  countList: pre_v3 + '/activityOrderPlatformWithHoldRecord/total', // 统计

  // 0元先享 支付订单
  // orderList: pre_v3 + '/activityOrderWalletList/page', //（旧）
  orderList: pre_v3 + '/activityOrderActivityMap/page', // （新）
  // 0元先享 支付订单 - 退款
  orderRefund: pre_v3 + '/activityOrderCancelRequestRecord/refund',
  // 一键解约
  cancelStatus: pre_v3 + '/activityOrderZeroPay/editEnableCancelStatus',
  serviceFree: pre_v3 + '/activityOrderCustomPrice/update',
  serviceFreeList: pre_v3 + '/activityOrderPriceTrace/page',

  // 活动折扣券列表
  // 折扣券列表（分页）
  couponList: pre_v3 + '/activityCouponIssued/page',
  // 折扣券列表导出
  couponListExcel: pre_v3 + '/activityCouponIssued/excel',
  // 折扣券累计数据
  couponListCount: pre_v3 + '/activityCouponIssued/count',
  // 关联用户列表（分页）
  userRelationList: pre_v3 + '/activityUserRelation/page',
  // 关联用户列表导出
  userRelationExcel: pre_v3 + '/activityUserRelation/excel',
  // 查看详情
  userRelationDetail: pre_v3 + '/activityUserRelation/findByCouponNo',

}

// 0元 活动报表
api.zeroOrder = {
  list1: pre_v3 + '/statementStatistics', // 活动落地页数据统计、活动流程数据统计
  list2: pre_v3 + '/contactUserStatistics', // 联系用户数据统计
  list3: pre_v3 + '/noInstallationCauseStatistics', // 不安装原因数据
  list4: pre_v3 + '/installStatistics', // 安装原因数据
  list5: pre_v3 + '/bindUserStatistics', // 绑定用户数据
  list6: pre_v3 + '/chargingStatistics', // 绑定用户数据
  list7: pre_v3 + '/channelStatistics', // 渠道数据统计
  list8: pre_v3 + '/dataOverview', // 数据概览
  list9: pre_v3 + '/channelTrendsLineChart', // 渠道趋势折线图
  list10: pre_v3 + '/contactUserStatistics', // 用户安卓数据统计-数据统计总览
  list11: pre_v3 + '/noInstallationCauseStatistics', // 不安装/不签约原因的报名订单数量占比
  list12: pre_v3 + '/installMeterStatistics', // 已安装米数  饼图、柱状图
  list13: pre_v3 + '/weeklyAvgChargeCount', // 单用户周均充电次数
  list14: pre_v3 + '/weeklyAvgChargeElec', // 单用户周均充电量
  list15: pre_v3 + '/totalChargeElec', // 累计充电量统计
  list16: pre_v3 + '/activityBindUserStatistics', // 用户已绑桩数据统计
  list17: pre_v3 + '/channelStatistics/excel',
}

export default api;
